import React from 'react';
import { Row } from 'reactstrap';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
const Page4 = ({
  asLabel,
  data,
  handleChangeObject,
  hasError,
  validationkeyValue
}) => {
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeObject
  });
  return <div>
            <Row className='my-2'>
                {renderWrapperField('crypto')}
            </Row>

            <h3 style={{
      fontWeight: 'bolder'
    }} className='pt-2'>
                What is a Money Services Business?
            </h3>
            <p>
                A Money Services Business (MSB) refers to a type of financial service provider that offers various services related to money transfers, currency exchange, and payment processing.
            </p>

            <p className='pt-1'>
                For the purposes of this application, FV Bank considers all of the following to be Money Services Businesses, whether a license is required or not in your jurisdictions. (Exchanges, OTC Providers, Liquidity Providers, Wallet Providers, Non-Bank Financial Institutions, VASPS, DLT's EMI's, PSD license holders, Brokers, Remittance Providers, and FX Providers.)
            </p>

            <Row className='my-2'>
                {renderWrapperField('Money_Services_Business')}
            </Row>

            {renderWrapperField('primaryBusinessModel', {
      className: "my-3"
    })}

            <h3 style={{
      fontWeight: 'bolder'
    }} className='pt-2'>
                What is a Merchant Acquirer and PSP?
            </h3>
            <p>
                A Merchant Acquirer is a financial institution or payment processor that facilitates the processing of credit or debit card transactions for a merchant. A Payment Service Provider (PSP) allows merchants to accept a wide variety of online payments, including credit cards, digital wallets, and bank transfers.
            </p>
            <Row className='my-2'>
                {renderWrapperField('Merchant_Acquirer_PSP')}
            </Row>

            <Row className='my-2'>
                {renderWrapperField('Regulated_Disclosure')}
            </Row>

            {renderWrapperField('Regulatory_Agency', {
      className: "my-3"
    })}

            {renderWrapperField('talkToSales', {
      className: "my-4"
    })}
        </div>;
};
export default Page4;
